import { palette } from '../__generated__/palette.js';

const focusHalo = `
 outline: 0;
 html:not(.src-focus-disabled) & {
	 box-shadow: 0 0 0 3px ${palette.focus[400]};
 }
`;
const focusHaloSpaced = `
 outline: 0;
 html:not(.src-focus-disabled) & {
	outline: 5px solid ${palette.focus[400]};
	outline-offset: 3px;
 }
`;

export { focusHalo, focusHaloSpaced };
